@if (data$ | async; as component) {
  <div class="category-container {{component.styleClasses}}" [style]="'background-color :'+ component.background">
    @switch (component.titleTag) {
      @case ('H1') {
        <h1
          class="h2-component title"
          [style.font-size]="component.titleSize"
          [style.font-weight]="component.titleBold === 'true' ? 'bold' : '400'"
          >
          {{component.title}}
        </h1>
      }
      @case ('H2') {
        <h2
          class="h2-component title"
          [style.font-size]="component.titleSize"
          [style.font-weight]="component.titleBold === 'true' ? 'bold' : '400'"
          >
          {{component.title}}
        </h2>
      }
      @default {
        <div
          class="h2-component title"
          [style.font-size]="component.titleSize"
          [style.font-weight]="component.titleBold === 'true' ? 'bold' : '400'"
          >
          {{component.title}}
        </div>
      }
    }
    <div
      class="text"
      [style.font-size]="component.textSize + 'px'"
      [style.font-weight]="component.textBold === 'true' ? 'bold' : '400'"
      [innerHTML]="component.text"
      >
    </div>
    @if (items$ | async; as components) {
      <div class="category-list">
        @for (component of components; track component; let i = $index) {
          @if (component) {
            <app-custom-item-category-blocks-component [item]="component"></app-custom-item-category-blocks-component>
          }
        }
      </div>
    }
  </div>
}
